import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { AllPersonnelContext } from "repository/stores/dashboard/personnel/personnel-all-provider";
import styles from "./dialogues-edit-other-qualifications-styles";
import {
  Grid,
  Button,
  TextField,
  FormControl,
  Paper,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  IconButton,
} from "@material-ui/core";
import SubjectIcon from "@material-ui/icons/Subject";
import DeleteIcon from "@material-ui/icons/Delete";
import { withSnackbar } from "notistack";
import { toast } from "react-toastify";
import Popup from "components/popup";

//Actions
import { updateNewPersonnel } from "repository/actions/data/dashboard/personnel";
const useStyles = makeStyles(styles);

function EditOtherQualificationsDialogue(props) {
  const classes = useStyles();

  const { setClose, isOpen, personId, person, setQualifications, user } = props;
  const {personnel, setPersonnel} = React.useContext(AllPersonnelContext);

  const [otherQualifications, setOtherQualifications] = React.useState([]);
  const [saveLoading, setSaveLoading] = React.useState(false);
  const [newQualification, setNewQualification] = React.useState(null);
  const [newQualificationError, setNewQualificationError] =
    React.useState(null);

  useEffect(() => {
    if (person && person != null) {
      if (person.other_qualifications) {
        setOtherQualifications(person.other_qualifications);
      }
    }
  }, [person]);

  const handleAddNewQualification = () => {
    if (newQualification == null) {
      setNewQualificationError("Cannot have an empty qualification");
    } else {
      let newOtherQualifications = [newQualification].concat(
        otherQualifications
      );
      setOtherQualifications(newOtherQualifications);
      setNewQualificationError(null);
    }
  };

  const handleSaveOtherQualifications = () => {
    if (user && user != null) {
      let patchData = { ...person, other_qualifications: otherQualifications };
      updateNewPersonnel( personId, patchData, user.idToken)
        .then((result) => {
          toast.success(
            `Other qualifications for ${person.firstName} ${person.lastName} updated`
          );
          setQualifications(otherQualifications);
          handleClose();
          setSaveLoading(false);
        })
        .catch((error) => {
          toast.error(
            "Oops! Something went wrong. Check that you have the correct information."
          );
          toast.dark(error.message);
          setSaveLoading(false);
        });
    }
  };

  const onPressedDeleteOtherQualification = (index) => {
    if (otherQualifications.length > index) {
      let newOtherQualifications = [];

      for (let [i, e] of otherQualifications.entries()) {
        if (i != index) {
          newOtherQualifications.push(e);
        }
      }
      setOtherQualifications(newOtherQualifications);
    }
  };

  const handleClose = () => {
    setClose();
  };

  return (
    <Popup
      title="Other Qualifications"
      subtitle="Edit the other qualifications for this person"
      isOpen={isOpen}
      handleCancel={() => handleClose()}
      handleAction={() => handleSaveOtherQualifications()}
      actionButtonTitle="Save"
      disabled={saveLoading}
      content={
        <div className={classes.root}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Paper className={classes.fullColumn}>
                <FormControl className={classes.formControl}>
                  <TextField
                    placeholder={"Ex: B.Sc in Mathematics"}
                    disabled={saveLoading}
                    required
                    helperText={newQualificationError}
                    error={newQualificationError != null}
                    label="New Other Qualification"
                    value={newQualification}
                    onChange={(event) =>
                      setNewQualification(event.target.value)
                    }
                    margin="normal"
                  />
                </FormControl>
                <FormControl className={classes.formControl}>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.submitButton}
                    onClick={() => handleAddNewQualification()}
                  >
                    Add Qualification
                  </Button>
                </FormControl>
              </Paper>
            </Grid>
            <Grid item xs={6}>
              <Paper className={classes.fullColumn}>
                <List className={classes.root}>
                  {otherQualifications.map((entry, index) => {
                    return (
                      <ListItem key={index}>
                        <ListItemAvatar>
                          <Avatar>
                            <SubjectIcon />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={
                            <Grid container spacing={3}>
                              <Grid item xs={9}>
                                {entry}
                              </Grid>
                              <Grid item xs={3}>
                                <IconButton
                                  aria-label="delete"
                                  color="primary"
                                  onClick={(event) => {
                                    onPressedDeleteOtherQualification(index);
                                  }}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </Grid>
                            </Grid>
                          }
                        />
                      </ListItem>
                    );
                  })}
                </List>
              </Paper>
            </Grid>
          </Grid>
        </div>
      }
    />
  );
}

export default withSnackbar(EditOtherQualificationsDialogue);
